module.exports = __webpack_public_path__ + "assets/2e43afc898d26c8c53f896fd49c54a7c.jpg";